import { render, staticRenderFns } from "./ItemizeCredit.vue?vue&type=template&id=cf67413c&scoped=true"
import script from "./ItemizeCredit.vue?vue&type=script&lang=js"
export * from "./ItemizeCredit.vue?vue&type=script&lang=js"
import style0 from "./ItemizeCredit.vue?vue&type=style&index=0&id=cf67413c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf67413c",
  null
  
)

export default component.exports